<template>
  <router-view />
</template>

<script>
export default {
  name: "training"
};
</script>

<style></style>
